import Carousel from "./Carousel";
import Header from "../../components/Header";
import ProductCenter from "./ProductCenter";
import AboutUs from "./AboutUs";
import DevelopmentHistory from "./DevelopmentHistory/";
import NewsTrands from "./NewsTrands";
export default {
  name: "Home",
  components: {
    Carousel: Carousel,
    ProductCenter: ProductCenter,
    AboutUs: AboutUs,
    DevelopmentHistory: DevelopmentHistory,
    NewsTrands: NewsTrands,
    Header: Header
  }
};